export enum OfferModal {
  APPLICATION_PROCESSING,
  AUTHENTICATION,
  BOOKING,
  ERROR_APPLICATION,
  FINISH_SUBSCRIPTION,
}
